import React from 'react';

const LeafletAppDownloadPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            폰피쉬 앱 다운로드 공유 페이지
          </h1>
          <div className="bg-gray-50 rounded-lg p-6 mb-6">
            <h2 className="text-xl font-semibold mb-4">고객 리플렛용 앱 다운로드 페이지</h2>
            <p className="text-gray-700 mb-4">
              이 페이지는 고객 리플렛용 앱 다운로드 공유 링크를 위한 페이지입니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeafletAppDownloadPage; 